import React, { useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { get, has } from 'lodash';

import DateTime from './DateTime';
import Dialog from '../../DesignSystem/Dialog';
import { postIsClosedForParticipation } from '../../../Utils/Post';

function ScheduleDialog({ onCloseDialog, open, errors, askToPublishAt, onSave, onChange }: any) {
  const [value, setValue] = useState(null);
  const intl = useIntl();

  useEffect(() => {
    setValue(askToPublishAt);
  }, [askToPublishAt]);

  const handleCloseDialog = () => {
    onCloseDialog();
    setValue(askToPublishAt);
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      id="post-schedule-dialog"
      aria-labelledby={intl.formatMessage({ id: 'DATE_TIME.LABEL.SCHEDULE_TITLE' })}
      label={intl.formatMessage({ id: 'DATE_TIME.LABEL.SCHEDULE_TITLE' })}
      title={<FormattedMessage id="DATE_TIME.LABEL.SCHEDULE_TITLE" />}
      TransitionProps={{
        onEnter: () => {
          setValue(askToPublishAt);
        },
      }}
      actions={
        <>
          <Button onClick={handleCloseDialog} color="primary">
            <FormattedMessage id="BUTTONS.CANCEL" />
          </Button>
          <Button
            variant="contained"
            disabled={
              !value ||
              value === askToPublishAt ||
              postIsClosedForParticipation(value) ||
              value.toString() === 'Invalid date'
            }
            onClick={async () => {
              await onChange(value);
              await onSave();
              handleCloseDialog();
            }}
            color="primary"
          >
            <FormattedMessage id="POSTS.SAVE" />
          </Button>
        </>
      }
    >
      <Box sx={{ pt: 1 }}>
        <DateTime
          slotProps={{ input: { autoFocus: true } }}
          helperText={get(errors, 'ask_to_publish_at')}
          error={has(errors, 'ask_to_publish_at')}
          label={intl.formatMessage({ id: 'DATE_TIME.LABEL.SCHEDULE_LABEL' })}
          value={value}
          onChange={async (event: any) => {
            const newValue = event?.toISOString();
            if (newValue) {
              onChange(newValue);
            }

            setValue(event);
          }}
          required
        />
      </Box>
    </Dialog>
  );
}

export default ScheduleDialog;
